
import { Vue, Options } from 'vue-class-component';
import QRCodeStyling, {
  DrawType,
  TypeNumber,
  Mode,
  ErrorCorrectionLevel,
  DotType,
  CornerSquareType,
  CornerDotType,
  Extension
} from 'qr-code-styling';

@Options({
  mounted : function() {
    this.qrCode.append(this.$refs["qrCode"]);
  },
  watch: {
    ['options.data']: function() {
      this.qrCode.update(this.options);
    }
  },
  methods: {
    download() {
      this.qrCode.download({ extension: this.extension as Extension })
    }
  },
  data: () => {
    const options = {
      width: 300,
      height: 300,
      type: 'svg' as DrawType,
      data: 'http://knox.edu/',
      image: 'favicon.jpg',
      margin: 0,
      qrOptions: {
        typeNumber: 0 as TypeNumber,
        mode: 'Byte' as Mode,
        errorCorrectionLevel: 'H' as ErrorCorrectionLevel
      },
      imageOptions: {
        hideBackgroundDots: true,
        imageSize: 0.5,
        margin: 0,
        crossOrigin: 'anonymous',
      },
      dotsOptions: {
        color: '#330066',
        // gradient: {
        //   type: 'linear', // 'radial'
        //   rotation: 0,
        //   colorStops: [{ offset: 0, color: '#8688B2' }, { offset: 1, color: '#77779C' }]
        // },
        type: 'classy' as DotType
      },
      backgroundOptions: {
        color: '#ffffff',
        // gradient: {
        //   type: 'linear', // 'radial'
        //   rotation: 0,
        //   colorStops: [{ offset: 0, color: '#ededff' }, { offset: 1, color: '#e6e7ff' }]
        // },
      },
      cornersSquareOptions: {
        color: '#000000',
        type: 'square' as CornerSquareType,
        // gradient: {
        //   type: 'linear', // 'radial'
        //   rotation: 180,
        //   colorStops: [{ offset: 0, color: '#25456e' }, { offset: 1, color: '#4267b2' }]
        // },
      },
      cornersDotOptions: {
        color: '#000000',
        type: 'dot' as CornerDotType,
        // gradient: {
        //   type: 'linear', // 'radial'
        //   rotation: 180,
        //   colorStops: [{ offset: 0, color: '#00266e' }, { offset: 1, color: '#4060b3' }]
        // },
      }
    };
    return {
      options,
      extension: 'svg',
      qrCode: new QRCodeStyling(options)
    }
  }
})
export default class QRCodeStylingComponent extends Vue {}
